import { motion } from "framer-motion";
import { BookOpen, Quote } from "lucide-react";
import { BOOKS, IMAGES } from "../data";

export default function Books() {
  return (
    <section id="books" data-testid="books-section" className="relative py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#070E1F]">
      <div className="max-w-3xl mb-14">
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-12 bg-[#D4AF37]" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#D4AF37]">Published Works</span>
        </div>
        <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight leading-[0.95]">
          Words That <span className="gold-text">Build Foundations</span>
        </h2>
        <p className="mt-5 text-lg text-[#A3A8B8]">
          Beyond the job site — two books on systems, identity, and breaking free from self-sabotage.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        {BOOKS.map((b, i) => (
          <motion.div
            key={b.title}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.12 }}
            data-testid={`book-${i}`}
            className="group relative flex flex-col sm:flex-row gap-6 bg-[#0C142A] border border-[#1D2847] p-8 hover:border-[#D4AF37]/50 transition-colors"
          >
            <div className="relative shrink-0 w-full sm:w-40 h-56 bg-gradient-to-br from-[#131E3D] to-[#050A15] border border-[#1D2847] flex flex-col items-center justify-center p-5 text-center overflow-hidden">
              <div className="absolute top-0 left-0 w-1.5 h-full bg-[#D4AF37]" />
              <BookOpen className="text-[#D4AF37] mb-3" size={26} />
              <div className="font-display font-black uppercase text-sm tracking-tight leading-tight text-[#F8F9FA]">{b.title}</div>
              <div className="mt-2 text-[10px] uppercase tracking-wider text-[#A3A8B8]">{b.subtitle}</div>
            </div>
            <div className="flex flex-col">
              <span className="text-xs uppercase tracking-wider text-[#D4AF37] font-bold">{b.tag}</span>
              <h3 className="font-display text-2xl font-bold tracking-tight mt-2">{b.title}</h3>
              <p className="text-sm text-[#A3A8B8] italic mt-1">{b.subtitle}</p>
              <p className="mt-4 text-[#C9CDD9] leading-relaxed flex-1">{b.desc}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-[#D4AF37] text-sm font-bold uppercase tracking-wider">
                <Quote size={15} /> Ask about signed copies
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
